import React, { useMemo } from 'react';
import { Skeleton } from 'antd';
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import { SalesPipelineDistribution } from '../../../types/dashboard';

interface SalesDetailPipelineChartProps {
  pipeline: SalesPipelineDistribution | null;
  loading: boolean;
  glassCardStyle: React.CSSProperties;
}

const SalesDetailPipelineChart: React.FC<SalesDetailPipelineChartProps> = ({
  pipeline,
  loading,
  glassCardStyle
}) => {
  const pipelineChartOptions = useMemo(() => {
    if (!pipeline) return {};

    const data = [
      { name: 'Cold', y: pipeline.cold, color: '#94a3b8' },
      { name: 'Hot', y: pipeline.hot, color: '#f87171' },
      { name: 'Prospect / RSV', y: pipeline.reservation, color: '#fbbf24' },
      { name: 'Closing (OK)', y: pipeline.closing, color: '#34d399' }
    ].filter(item => item.y > 0);

    return {
      chart: {
        type: 'pie',
        backgroundColor: 'transparent',
        height: 420,
        style: { fontFamily: 'inherit' }
      },
      title: {
        text: 'Sebaran Suhu Portofolio',
        align: 'left',
        style: { fontSize: '14px', fontWeight: 'bold', color: '#1e293b' }
      },
      tooltip: {
        pointFormat: '{series.name}: <b>{point.y} Leads ({point.percentage:.1f}%)</b>',
        backgroundColor: 'rgba(255, 255, 255, 0.95)',
        borderRadius: 8,
        borderWidth: 1,
        borderColor: '#e2e8f0',
      },
      accessibility: {
        point: { valueSuffix: '%' }
      },
      plotOptions: {
        pie: {
          allowPointSelect: true,
          cursor: 'pointer',
          dataLabels: {
            enabled: true,
            format: '<b>{point.name}</b>: {point.y}',
            style: { color: '#475569', fontSize: '11px', textOutline: 'none' }
          },
          innerSize: '55%',
        }
      },
      credits: { enabled: false },
      series: [{
        name: 'Jumlah',
        colorByPoint: true,
        data
      }]
    };
  }, [pipeline]);

  return (
    <div className="glass-card-interactive" style={{ ...glassCardStyle, height: '510px' }}>
      {loading || !pipeline ? (
        <Skeleton active paragraph={{ rows: 6 }} />
      ) : (
        <HighchartsReact highcharts={Highcharts} options={pipelineChartOptions} />
      )}
    </div>
  );
};

export default SalesDetailPipelineChart;
